export const BASE_URL: string = process.env.NEXT_PUBLIC_BASE_URL || '';
export const NO_INTERNET_ERR = 'No internet connection';
export const FALLBACK_ERR = 'Something went wrong';
export const SESSION_EXP_ERR = 'Session expired, login again!';
